export const getImageUrl = (baseUrl, imagePath) => {
  if (!imagePath) return "";
  const base = (baseUrl || "https://api.ihartglobal.org").replace(/\/$/, "");
  const path = String(imagePath).replace(/\\/g, "/").replace(/^\//, "");
  return `${base}/${path}`;
};
